import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptAlaska = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Alaska Non-Profit State Filing Requirements & Compliance"
          description="Learn Alaska's non-profit filing requirements, including Forms 990, registrations, and deadlines. Stay compliant with state and federal laws."
          keywords=" "
          canonical="nonprofit-taxes/alaska-state-filing-requirements/"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/ak-state-landing-img.webp" />
                <source srcSet="/assets/images/ak-state-landing-img.png" />
                <img
                  src="/assets/images/ak-state-landing-img.png"
                  alt="Alaska State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Alaska State </span>
                </span>{' '}
                Filing
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Nonprofits in Alaska must comply with specific state
                requirements to maintain their good standing and tax-exempt
                status.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  {/* <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=alaska`}
                  >
                    Start Filing Now
                  </Button> */}
                  {/* <Typography
                    variant="body2"
                    sx={{
                      mt: 1,
                      textAlign: 'center',
                      fontSize: { xs: 11, sm: 14 },
                    }}
                  >
                    As low as <b>$0.99 per</b> W-2 state filing form
                  </Typography> */}
                </Box>
              </Stack>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/ak-state-landing-img-sm.webp" />
                <source srcSet="/assets/images/ak-state-landing-img-sm.png" />
                <img
                  src="/assets/images/ak-state-landing-img-sm.png"
                  alt="Alaska State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          State Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.commerce.alaska.gov/web/cbpl/BusinessLicensing/Forms.aspx"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                {' '}
                                Articles of Incorporation
                              </Link>
                              : Required to establish a non-profit corporation
                              in Alaska.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.commerce.alaska.gov/web/cbpl/Corporations/Forms.aspx"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Initial Report
                              </Link>
                              : Required within six months of incorporation to
                              provide information about the organization’s
                              officers and ownership.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.law.alaska.gov/department/civil/charitable.html"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Charitable Organization Registration
                              </Link>{' '}
                              : Required for organizations soliciting donations.
                            </li>
                            <li>
                              {' '}
                              <Link
                                href="https://www.commerce.alaska.gov/web/cbpl/Corporations/Forms.aspx"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                {' '}
                                Biennial Report
                              </Link>
                              : Required every two years to maintain good
                              standing.
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 18 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                Form 990: Return of Organization Exempt from
                                Income Tax
                              </Link>
                            </li>
                            <li style={{ marginBottom: 18 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990-ez/"
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                Form 990-EZ: Short Form Return of Organization
                                Exempt from <br /> Income Tax
                              </Link>
                            </li>
                            <li style={{ marginBottom: 18 }}>
                              <Link
                                href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=form990ez`}
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                Form 990-N (e-Postcard): Electronic Notice for
                                Small Tax-Exempt Organizations
                              </Link>
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Non-profit organizations in Alaska must comply with various
                state regulations to maintain their tax-exempt status and
                operate legally.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                These requirements include registration with the Alaska
                Secretary of State, obtaining a charitable organization
                registration if soliciting donations, and filing annual and
                biennial reports.
              </Typography>
              <Typography
                variant="body1"
                sx={{ mb: 1, textAlign: 'left', fontWeight: 600 }}
              >
                Key regulatory bodies overseeing non-profit filings
                include:{' '}
              </Typography>
              <Box
                component="div"
                sx={{ mb: 2, ml: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  Alaska Division of Corporations, Business and Professional
                  Licensing
                </li>
                <li>Alaska Department of Revenue</li>
                <li>Internal Revenue Service (federal-level requirements)</li>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/ak-state-filing-img.webp" />
                <source srcSet="/assets/images/ak-state-filing-img.png" />
                <img
                  src="/assets/images/ak-state-filing-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{ px: 3, py: 5, borderRadius: 5, maxWidth: 900 }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Here’s what non-profits must do:
                  </Typography>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{ textAlign: 'center' }}
                  >
                    <Box
                      component="ul"
                      sx={{
                        listStyleType: 'none',
                        paddingLeft: 0,
                        textAlign: 'left',
                        ml: { xs: 0, sm: 3 },
                        '& li svg': { float: 'left', fontSize: 27 },
                      }}
                    >
                      <li style={{ marginBottom: 16 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Tax-Exempt Status Verification:
                        </span>{' '}
                        <br />
                        Non-profits must verify and maintain their federal
                        tax-exempt status under section 501(c) of the Internal
                        Revenue Code.
                      </li>
                      <li style={{ marginBottom: 16 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Federal Tax Return Requirements{' '}
                        </span>{' '}
                        <br />
                        Non-profits operating in Alaska typically file Form 990,
                        990-EZ, or 990-N based on their annual gross receipts:
                      </li>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ marginBottom: 16 }}>
                          <FastForwardOutlinedIcon
                            sx={{ color: '#1da94a', mr: 1 }}
                          />
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            990-N (e-Postcard):
                          </span>{' '}
                          For gross receipts of $50,000 or less.{' '}
                        </li>
                        <li style={{ marginBottom: 16 }}>
                          <FastForwardOutlinedIcon
                            sx={{ color: '#1da94a', mr: 1 }}
                          />
                          <span style={{ fontWeight: 600 }}> 990-EZ:</span> For
                          gross receipts under $200,000 and total assests under
                          $500,000.
                        </li>
                        <li style={{ marginBottom: 16 }}>
                          <FastForwardOutlinedIcon
                            sx={{ color: '#1da94a', mr: 1 }}
                          />
                          <span style={{ fontWeight: 600 }}> 990:</span> For
                          gross receipts gross receipts exceeding $200,000 and
                          total assets of $500,000 or more.
                        </li>
                      </ul>
                      <li style={{ marginBottom: 16 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Alaska Biennial Report:
                        </span>
                        <br />
                        Every non-profit must file a Biennial Report with the
                        Department of Commerce, Community, and Economic
                        Development (DCCED) to maintain its status as a
                        corporation in good standing.
                      </li>

                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Charitable Solicitation Registration:{' '}
                        </span>{' '}
                        <br />
                        Depending on the nature and scope of their solicitation
                        efforts, nonprofits engaging in fundraising activities
                        may need to register with the Alaska Department of Law.
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 }, px: { xs: 2, sm: 6, md: 18 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                Staying on top of deadlines is crucial for non-profits to avoid
                penalties or loss of good standing.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1, textAlign: 'left' }}>
                Below are the key deadlines for non-profit filings in Alaska:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Form
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Initial Report
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due within six months of incorporation.
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Charitable Solicitation Registration
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Deadlines vary depending on the type of registration
                          and reporting required. This form must be filed before
                          soliciting state contributions. It must also be
                          renewed annually by September 1st.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          IRS Form 990
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due by the 15th day of the 5th month after the fiscal
                          year ends. Small organizations (gross receipts ≤
                          $50,000) must file Form 990-N by the 15th day of the
                          5th month.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            backgroundColor: '#fff',
                            textAlign: 'left',
                            fontSize: 16,
                          }}
                        >
                          Biennial Report
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          It is due on July 2nd of every other year, matching
                          the year of their filing.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 4,
                      mb: 2,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=alaska`}
                  >
                    Get Started
                  </Button>
                </Box>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To maintain compliance, non-profits must register with the Alaska
            Secretary of{' '}
            <Hidden smDown>
              <br />
            </Hidden>
            State and the Attorney General&apos;s Office. The registration
            process includes:
          </Typography>
          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Initial Registration
                  </Typography>

                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      To operate legally as a non-profit in Alaska,
                      organizations must register with the Secretary of State by
                      submitting their Articles of Incorporation along with a
                      $50 filing fee.
                    </li>
                    <li>
                      After incorporation, they must also file a Charitable
                      Organization Registration if they intend to solicit
                      donations, which requires an additional fee of $40.
                    </li>
                  </Box>

                  <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                    <li>
                      File the Charitable Organization Annual Report Form with
                      updated financial details for a fee of $40.
                    </li>
                    <li>
                      Ensure compliance with Alaska&apos;s Charitable
                      Solicitation Act.
                    </li>
                  </Box>

                  <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                    <li>
                      Non-profits incorporated in Alaska must file a biennial
                      report with the Division of Corporations, Business, and
                      Professional Licensing to remain in good standing.{' '}
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Box component="div" sx={{ mb: 0, '& li': { mb: 2.5 } }}>
                    <li>
                      Ensure that all contact details, registered agent info,
                      and board member data are current with the state.{' '}
                    </li>
                    <li>
                      Compile accurate financial records, including income,
                      expenses, assets, and liabilities, for transparency and
                      reporting purposes.
                    </li>
                    <li>
                      File the required annual or biennial report with the state
                      to maintain active status and legal compliance.{' '}
                    </li>
                    <li>
                      Submit the necessary forms and fees to keep your Alaska
                      business license valid and up to date.{' '}
                    </li>
                    <li>
                      Submit the appropriate IRS Form 990 (e.g., 990, 990-EZ, or
                      990-N) based on your organization’s size and revenue.{' '}
                    </li>
                    <li>
                      Keep thorough documentation of board meetings, bylaws,
                      financials, and other key governance materials.{' '}
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Reliable Nonprofit E-Filing Platform
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone provides nonprofits with efficient and compliant tax filing
          and reporting solutions.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=alaska`}
          >
            E-File Now
          </Button>
        </Box> */}
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Are all non-profits required to file an Annual Report?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    Yes, almost all non-profit corporations registered in Alaska
                    must file an Annual Report, regardless of their current
                    activity level or revenue.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. How do I start a non-profit in Alaska?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      To start a non-profit in Alaska, you need to file Articles
                      of Incorporation with the Secretary of State, obtain a
                      Federal Employer Identification Number (EIN), and register
                      as a charitable organization if you plan to solicit
                      donations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What happens if a non-profit fails to file the Biennial
                  Report?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Failure to file can result in the non-profit’s status
                      being revoked by the{' '}
                      <Link
                        href="https://www.commerce.alaska.gov/web/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Alaska DCCED
                      </Link>
                      , making it ineligible to operate legally in the state.
                    </Typography>
                    <Typography variant="body1">
                      This means the state could legally consider the non-profit
                      to be inactive and potentially lose its ability to operate
                      until the report is filed and any associated penalties are
                      paid.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Is there a fee for filing the Biennial Report?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Yes, the state filing fee to file this report is $25.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Can I file my forms online?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Yes, many forms can be filed electronically through the
                      online portal provided by the{' '}
                      <Link
                        href="https://law.alaska.gov/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        State of Alaska Department of Law
                      </Link>{' '}
                      and the{' '}
                      <Link
                        href="https://www.commerce.alaska.gov/web/cbpl/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Division of Corporations
                      </Link>
                      .
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative sources
                      including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://www.commerce.alaska.gov/web/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Alaska Department of Commerce, Community, and Economic
                          Development
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://dor.alaska.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Alaska Department of Revenue
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.akleg.gov/basis/statutes.asp"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Official Alaska State Statutes
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.commerce.alaska.gov/web/cbpl/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Alaska Division of Corporations
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://law.alaska.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Alaska Department of Law
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          IRS Charities and Nonprofits
                        </Link>
                      </li>{' '}
                    </Box>
                    <Typography variant="body2">
                      This resource page serves as a comprehensive guide for
                      understanding Alaska&apos;s FTB state filing requirements
                      for non-profits, ensuring that organizations remain
                      compliant while focusing on their mission effectively.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptAlaska;
